import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';
import { CCOButton, CCOAlert } from '../util/Components.js';
import {update, get } from '../util/Utility.js';
import EditEventView from '../ministry/events/EditEventView.js';
import EditSermonView from '../sermons/EditSermonView.js';
import EditAnnoucementView from '../ministry/announcements/EditAnnouncementView.js';


const components = {
  event: EditEventView,
  sermon: EditSermonView,
  announcement: EditAnnoucementView
};

class PanelView extends Component {

  constructor(props) {
    super(props);

    this.defaultState = {
      deleteAlert: false,
      networkAlert: false
    };

    this.state = {
      deleteAlert: false,
      networkAlert: false
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps !== this.props && this.state.deleteAlert) {
      this.setState({deleteAlert: false});
    }
  }

  edit() {
    this.setState({editing: true, deleteAlert: false});
  }

  doneEditing() {
    console.log("done editing");
    //this.props.setState(updatedObject.object !== null ? updatedObject : {object: this.props.object});
    this.setState({editing: false});
  }

  approve(level, type) {
    var obj = {};
    obj[level] = this.props.user.uid;

    var localObject = this.props.object;
    localObject[level] = this.props.user.uid;

    update(type + '/' + this.props.object.key, this, obj).then(() => {
      if (this.props.type === "approval4")
        window.show('success', "Event Published", "The event was sent out and is now visible in the app");
      else
        window.show('success', "Event Approved", "The event has been sent on to the next approver");
    }).catch(() => {
      this.setState({networkAlert: true});
    });

    //this.props.remove(this.props.object.key);
  }

  contactCreator() {
    if (this.props.object.originator) {
      get("leaders/" + this.props.object.originator, this, null, null, false).then(data => {
        window.location.href = "mailto:" + data.email + "?subject=" + encodeURIComponent("Question About Event: " + this.props.object.title);
      });
    } else {
      get("ministries/" + this.props.object.ministryID, this, null, null, false).then(ministry => {
        get("leaders/" + ministry.leaders[0], this, null, null, false).then(data => {
          window.location.href = "mailto:" + data.email + "?subject=" + encodeURIComponent("Question About Event: " + this.props.object.title);
        });
      });
    }
  }

  delete() {
    let type = this.props.subtype || this.props.type;
    if (!this.state.deleteAlert) {
      this.setState({deleteAlert: true});
    } else if (type === "event" && this.props.object.show) {
      update('events/' + this.props.object.key, this, {canceled: true}).then(() => window.show('success', "Event Canceled", "You will have to contact a system administrator if you want to undo this."));
    }
    else {
      window.base.remove(type + 's/' + this.props.object.key, (err) => {
        console.log(err);
        if (err) {
          this.setState({networkAlert: true, deleteAlert: false});
          setTimeout(() => this.setState({networkAlert: false}), 3000);
        }
        // else {
        //   this.props.remove(this.props.object.key);
        // }
      });
    }
  }

  cancelDelete() {
    this.setState({deleteAlert: false});
  }

  render() {

    var divStyle = {
      maxWidth: 500,
      color: 'black'
    };

    let type = this.props.subtype || this.props.type;

    var EditView = components[type];

    return (
      <div style={divStyle}>
        {EditView && <EditView done={this.doneEditing.bind(this)} show={this.state.editing} {...this.props} />}
        <Panel>
          {this.props.children}

          <div style={{width: 200}}>
            {this.props.approve && <div>
              <CCOButton text={this.props.type === "approval4" ? "Publish Event" : "Approve"} onClick={this.approve.bind(this, this.props.type, this.props.subtype + "s")} type="primary" />
              <div style={{height: 10}} />
            </div>}

            {this.props.contact && <div>
              <CCOButton text="Contact Creator" onClick={this.contactCreator.bind(this)} type="primary" />
              <div style={{height: 10}} />
            </div>}

            {this.props.edit /* && !this.props.object.show */ && <div>
              <CCOButton text="Edit" onClick={this.edit.bind(this)} type="primary" />
              <div style={{height: 10}} />
            </div>}

            {this.props.delete && <center>
              <CCOButton type="destructive" text={(this.state.deleteAlert ? "Confirm " : "") + (this.props.deleteButtonTitle || "Delete")} onClick={this.delete.bind(this)} />
              <div style={{height: 5}} />
              {this.state.deleteAlert && <CCOButton type="primary" text="Cancel" onClick={this.cancelDelete.bind(this)} />}
              <div style={{height: 5}} />
              <CCOAlert in={this.state.deleteAlert} type="danger" title={"Click Again to " + (this.props.deleteButtonTitle || "Delete")} content={this.props.deleteConfirmationSubtext || "Note that once deleted, this " + type + " cannot be recovered."} />
            </center>}
          </div>

          <CCOAlert in={this.state.networkAlert} type="warning" title="Network Error" content="Could not save because we could not connect to the server, please try again later." />

        </Panel>
      </div>
    );
  }
}

export default PanelView;



/** WEBPACK FOOTER **
 ** ./src/model/PanelView.js
 **/